const RegisterInitialState = {
    user: {
        mail: '',
        showMailError: false,
        isValidMail: false,
        password: '',
        isValidPassword: false,
        showPasswordError: false,
        acceptedRules: false,
    },
    error: '',
    errorMail: '',
    isPending: false,
};

export default RegisterInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/Register/RegisterInitialState.js